__turbopack_context__.v({
  "breadcrumbs": "Hero4-module__bWFPgq__breadcrumbs",
  "content": "Hero4-module__bWFPgq__content",
  "heading": "Hero4-module__bWFPgq__heading",
  "image": "Hero4-module__bWFPgq__image",
  "intro": "Hero4-module__bWFPgq__intro",
  "preamble": "Hero4-module__bWFPgq__preamble",
  "root": "Hero4-module__bWFPgq__root",
  "tag": "Hero4-module__bWFPgq__tag",
});
